import { render, staticRenderFns } from "./message-popover.vue?vue&type=template&id=6718c234&scoped=true&"
import script from "./message-popover.vue?vue&type=script&lang=js&"
export * from "./message-popover.vue?vue&type=script&lang=js&"
import style0 from "./message-popover.vue?vue&type=style&index=0&id=6718c234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6718c234",
  null
  
)

export default component.exports